class CollectionHeader extends HTMLElement {

  get open() {
    return this.hasAttribute('open');
  }

  constructor() {
    super();

    if (this.querySelector('[toggle-description]')) {
      this.querySelector('[toggle-description]').addEventListener('click', e => {
        this.toggleDescription();
      })
    }
  }

  toggleDescription() {
    if (this.open) {
      this.removeAttribute('open')
    } else {
      this.setAttribute('open', '');
    }

  }
}

customElements.define('collection-header', CollectionHeader);